import { transformRoutes } from '@backoffice-frontend/common'
import { StopNetworkAlertsAreaId } from './StopNetworkAlertsAreaId'

const baseRoute = '/stop-network-alerts'

export const StopNetworkAlertsAreaRoutes = transformRoutes({
  route: baseRoute,
  title: `${StopNetworkAlertsAreaId}:title`,
})
